import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  status() {
    return faker.helpers.weightedArrayElement([
      { value: 'unavailable', weight: 20 },
      { value: 'available', weight: 60 },
      { value: 'expired', weight: 20 },
    ]);
  },

  url(i) {
    if (this.status !== 'available') {
      return null;
    }

    return { zip: `#vfd-call-log-transcription-id=${i}` };
  },

  expiredAt() {
    switch (this.status) {
      case 'available':
        return faker.date.soon({ days: 60 }).toJSON();
      case 'expired':
        return faker.date.recent({ days: 10 }).toJSON();
      default:
        return null;
    }
  },
});
